import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Tooltip from '../../../../components/Tooltip';

const WithTooltipIcon = ({
  children,
  tooltipContent,
  placement,
  tooltipMaxWidth = 300,
  gap = 4,
  overlayClassName,
}) => (
  <div className={`d-flex align-items-center gap-${gap}`}>
    {children}
    {tooltipContent && (
      <Tooltip
        colorVariant="light"
        content={tooltipContent}
        placement={placement}
        overlayStyle={{ maxWidth: tooltipMaxWidth }}
        overlayClassName={cx('title-caption-tooltip', overlayClassName)}
      >
        <i className="hicon-question-circle text-muted text-16" />
      </Tooltip>
    )}
  </div>
);

WithTooltipIcon.propTypes = {
  children: T.node.isRequired,
  tooltipContent: T.node,
  placement: T.string,
  tooltipMaxWidth: T.number,
  gap: T.number,
  overlayClassName: T.string,
};

export default WithTooltipIcon;
